import { useParams } from 'react-router-dom'
import PageCalling from 'src/components/common/PageCalling'

import useAPI from 'src/hooks/useAPI'
import Footer from 'src/components/common/Footer'
import Banner from 'src/components/common/Banner'
import Terms from 'src/components/views/join/Terms'
import JoinSubmit from 'src/components/views/join/JoinSubmit'
import PhoneVerification from 'src/components/views/join/PhoneVerification'
import FloatingButton from 'src/components/views/join/FloatingButton'

import { useEffect } from 'react'
import { authKeyState, PartnerListData, TelTypeState, TermsListState, uiData, isViewState } from 'src/recoil/common'
import { useRecoilState, useSetRecoilState } from 'recoil'
import useMoveScroll from 'src/hooks/useMoveScroll'
import { PramsKeys } from 'src/types/type'
import Faq from 'src/components/common/Faq'
import styled from 'styled-components';
import useViewButton from 'src/hooks/useViewButton'
import { MktFormWrap } from 'src/styles/styledcomponent/views/join/MktForm'
import useSubmit from 'src/hooks/useSubmit'
import MvnoModal from 'src/components/views/join/MvnoModal'
import { convertTermsData } from 'src/service/join'
import VulnerableCheckModal from 'src/components/views/join/VulnerableCheckModal'

const MktWrap = styled(MktFormWrap)``
const FloatingButtonLayout = styled.div`
  padding-bottom: 75px;
`;
const OutLayout = styled.div`
  background:#ebebeb;
`
const CommonLayout = styled.div`
  max-width: 430px;
  margin: 0 auto;
`;

const Join = (): JSX.Element => {
  const { pcode, authKey, telecom } = useParams<PramsKeys>()
  const api = useAPI('requestTermsList')
  const submit = useSubmit(pcode ?? '')
  const { data: getTermsData, isSuccess, isLoading } = api?.useSetQuery({ PCode: pcode })
  const setAuthKey = useSetRecoilState(authKeyState)
  const setTermsListState = useSetRecoilState(TermsListState)
  const setPartnerData = useSetRecoilState(PartnerListData)
  const [{ layoutsInsert: { mainBg }}, setUiData] = useRecoilState(uiData)
  const [isView, setIsView] = useRecoilState(isViewState);
  const setTelType = useSetRecoilState(TelTypeState)
  const { RefElement, onMoveToElement, RefInput } = useMoveScroll()
  const { RefVertification, observeIntersection } = useViewButton()

  const isErrorPartner = getTermsData?.Header.ErrCode === 1011

  useEffect(() => {
    switch (isSuccess) {
      case pcode === 'pinc_01':
        return setAuthKey(authKey)
      default:
    }
  }, [isSuccess, authKey, pcode, setAuthKey])

  // 스크롤내에 인증 컴포넌트가 포함되지 않으면 플로팅버튼 랜더링
  observeIntersection(RefVertification.current,setIsView);
  useEffect(() => {
    if (isSuccess && !isErrorPartner) {
      const data = getTermsData?.Body
      setTelType(Number(telecom))
      setTermsListState(convertTermsData(data))
      setPartnerData(data?.Partner)
      setUiData(JSON.parse(atob(data?.Partner.UiData)))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, isErrorPartner, getTermsData?.Body, setPartnerData, setTermsListState, setTelType, setUiData])

  useEffect(() => {
    window.onbeforeunload = function pushRefresh() {
      window.scrollTo(0, 0);
    };
  }, [isSuccess]);


  return (
    <OutLayout>
      <CommonLayout>
        <PageCalling active={isLoading} />
        { isSuccess && (
          <MktWrap mainBg={mainBg}>
            <Banner RefElement={RefElement} />
            <PhoneVerification onMoveToElement={onMoveToElement} RefInput={RefInput} RefElement={RefVertification} submit={submit} />
            {isView && <FloatingButton onMoveToElement={onMoveToElement} RefInput={RefInput} />}
            {!isErrorPartner && <Terms data={getTermsData?.Body?.Terms} />}
            <JoinSubmit submit={submit} />
            <Faq/>
            <Footer />
            <FloatingButtonLayout />
            <MvnoModal submit={submit} />
            <VulnerableCheckModal submit={submit} />
          </MktWrap>
        )}
      </CommonLayout>
    </OutLayout>
  )
}
export default Join
